var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:`${_vm.id}__super_multi_section_list`,staticClass:"super-multi-section-list"},[(_setup.hasCatalogList)?_c(_setup.CatalogList,{key:_vm.id,attrs:{"id":_vm.id,"catalog-list":_setup.catalogList}}):_c('div',{staticClass:"min-h-screen"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }